import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../i18n";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { ChevronDown } from "lucide-react";
import { api } from "../lib/api";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language) || SUPPORTED_LANGUAGES[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem("mec_lang", code);
    // Sync language with backend if logged in (best-effort, ignore errors)
    if (localStorage.getItem("mec_token")) {
      api.put("/auth/language", { language: code }).catch(() => {});
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-9 px-2.5 gap-1.5" data-testid="lang-switcher">
          <span className="text-base leading-none">{current.flag}</span>
          {!compact && <span className="text-xs font-medium uppercase">{current.code}</span>}
          <ChevronDown className="w-3 h-3 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => change(lang.code)}
            className={`cursor-pointer ${current.code === lang.code ? "bg-blue-50 font-semibold" : ""}`}
            data-testid={`lang-${lang.code}`}
          >
            <span className="mr-2 text-base">{lang.flag}</span>
            <span className="text-sm">{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
